import React from 'react';
import Icon from '../../../components/AppIcon';

const LoginFooter = () => {
  const currentYear = new Date()?.getFullYear();

  return (
    <div className="mt-8 text-center space-y-4">
      {/* Help Section */}
      <div className="p-4 bg-muted rounded-lg">
        <div className="flex items-start space-x-3">
          <Icon name="Info" size={16} className="text-primary flex-shrink-0 mt-0.5" />
          <div className="text-left">
            <p className="text-sm font-medium text-text-primary mb-1">
              Identifiants de démonstration
            </p>
            <div className="text-xs text-text-secondary space-y-1">
              <p><strong>Admin:</strong> admin / admin123</p>
              <p><strong>Manager:</strong> manager / manager456</p>
              <p><strong>Utilisateur:</strong> user / user789</p>
            </div>
          </div>
        </div>
      </div>

      {/* Support Links */}
      <div className="flex items-center justify-center space-x-6 text-sm text-text-secondary">
        <button className="hover:text-text-primary transition-smooth flex items-center space-x-1">
          <Icon name="HelpCircle" size={14} />
          <span>Aide</span>
        </button>
        <button className="hover:text-text-primary transition-smooth flex items-center space-x-1">
          <Icon name="Mail" size={14} />
          <span>Support</span>
        </button>
        <button className="hover:text-text-primary transition-smooth flex items-center space-x-1">
          <Icon name="Phone" size={14} />
          <span>Contact</span>
        </button>
      </div>

      {/* Copyright */}
      <div className="pt-4 border-t border-border">
        <p className="text-xs text-text-secondary">
          © {currentYear} KitchenQuote Pro. Tous droits réservés.
        </p>
      </div>
    </div>
  );
};

export default LoginFooter;